import { HttpError } from './HttpError';

export class UnderReviewError extends HttpError {
	constructor(options?: { cause?: unknown }) {
		super('Page under review', 403, 'petition_under_review', options);
	}
}
